import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { AuthService } from '@modules/auth';
import { SharpenService } from '@services/SharpenService/sharpen.service';
import { ISharpenModule, ISharpenVideo, ISharpenVideoData, SharpenContentType } from '@shared/models/sharpen-data-model';
import { Observable, of } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

interface IAttachmentsVideo {
  [key: number]: Observable<ISharpenVideoData>;
}

@Component({
  selector: 'app-sharpen-content',
  templateUrl: './sharpen-content.component.html',
  styleUrls: ['./sharpen-content.component.scss']
})
export class SharpenContentComponent implements OnInit, AfterViewInit, OnDestroy {
  public types = SharpenContentType;

  @ViewChildren('videoplayer') videoplayers: QueryList<HTMLVideoElement>

  @Input() content: ISharpenModule;
  @Input() creationMode = false;

  private _videoAttachments: IAttachmentsVideo = {};

  constructor(
    private sharpen: SharpenService,
    public authService: AuthService,
  ) { }

  ngOnInit(): void {
    if (!this.creationMode) {
      this.sharpen.trackModuleView(this.content.title, this.authService.currentUserValue.id).subscribe((res) => console.log(res))
    }
  }

  ngAfterViewInit(): void {
    // if (!this.creationMode && this.videoplayers?.toArray()?.length) {
    //   this.videoplayers.toArray().forEach((player: HTMLVideoElement) => {
    //     player.addEventListener('progress', this.onTrackPlayProgress.bind(this))
    //   })
    // }
  }

  ngOnDestroy(): void {
    // if (this.videoplayers?.toArray()?.length) {
    //   this.videoplayers.toArray().forEach((player: HTMLVideoElement) => {
    //     player?.removeEventListener('progress', this.onTrackPlayProgress.bind(this))
    //   })
    // }
  }

  public getVideoData(id: number): Observable<ISharpenVideoData> {
    if (!this._videoAttachments[id]) {
      this._videoAttachments[id] = this.sharpen.getVideoById(id).pipe(shareReplay(1));
    }
    return this._videoAttachments[id];
  }

  private onTrackPlayProgress(event: Event) {
    console.log(event)
  }
}
